<template>
    <div>
		<vs-dialog
			:width="alert.width"
			v-model="alert.show"
            :loading="loading"
			blur
			prevent-close
            @close="closeAlert"
            class="text-center">
			<template #header>
                <h4 class="not-margin">
                    {{ $tc(`${title}`) }}
                </h4>
            </template>


            <div class="con-form text-center">
                <vs-row class="mh" align="center" justify="space-around" direction="column">
                    <vs-col w="8" class="mb-1">
                        <vs-input v-model="auth.username" placeholder="Email" data-cy="model-auth_email-text">
                            <template #icon>
                                <mu-icon value="person"></mu-icon>
                            </template>
                        </vs-input>
                    </vs-col>
                    <vs-col w="8" class="mt-1">
                        <!-- :progress="getProgress" -->
                        <vs-input
                            data-cy="model-auth_password-text"
                            type="password"
                            v-model="auth.password"
                            placeholder="Password"
                            :visiblePassword="hasVisiblePassword"
                            @click-icon="hasVisiblePassword = !hasVisiblePassword">
                            <template #icon>
                                <mu-icon :value="(!hasVisiblePassword) ? 'visibility' : 'visibility_off'"></mu-icon>
                            </template>
                            <!-- <template v-if="auth.password.length === 6" #message-success>
                                Secure password
                            </template> -->
                        </vs-input>
                    </vs-col>
                </vs-row>
            </div>

            <template #footer>
                <div class="footer-dialog text-center">

                    <vs-row class="mh" align="center" justify="space-around" direction="column">
                        <vs-col w="8" class="mb-1">
                            <vs-button block @click="signIn"  data-cy="model-auth-btn">
                                {{ alert.custom_button_label !== null ? alert.custom_button_label : $tc('traveller.sign_in') }}
                            </vs-button>
                        </vs-col>
                    </vs-row>

                    <div class="new">
                        {{ $tc('traveller.no_account') }} <a href="https://viajero.vallartaplus.mx/" target="_blank" data-cy="traveller-no_account-button"> {{ $tc('traveller.redirect') }} </a>
                        <br>
                        <span @click="recovery =! recovery" style="cursor: pointer;" v-if="auth.username !== null && auth.username.length > 5"> {{ $tc('traveller.recovery') }} </span>
                    </div>
                </div>
            </template>
		</vs-dialog>

        <vs-dialog
            blur
            prevent-close
            v-model="recovery"
            class="text-center">

            <div class="row text-center mt-5 mb-5 ml-4">
                <div class="col icon">
                    <img src="/images/traveller/sms.png" style="width: 60px;" alt="sms" @click="recoveryPassword('sms')">
                </div>
                <div class="col icon">
                    <img src="/images/traveller/whatsapp.png" style="width: 60px;" alt="whatsapp" @click="recoveryPassword('whatsapp')">
                </div>
                <div class="col icon">
                    <img src="/images/traveller/mail.png" style="width: 60px;" alt="email" @click="recoveryPassword('email')">
                </div>
            </div>
            <template #footer>
                <div class="footer-dialog text-center">
                    <vs-button block color="danger" @click="closeRecovery">
                        {{ $tc('traveller.close_recovery') }}
                    </vs-button>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>

    /*import sms from '@@/images/traveller/sms'
    import mail from '@@/images/traveller/mail'
    import whatsapp from '@@/images/traveller/sms'*/
    // HELPERS
	import _GlobalHelper from '@/store/helpers/global'
	// VUEX
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	// COMPONENTS
	import BCard from '@/components/BCard/Index'

    export default {
		name: 'alert-authenticate',
		components: {
			BCard: BCard
        },
        props: {
            title: {
                type: String
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
		data() {
			return {
			    /*sms: sms,
                mail: mail,
                whatsapp: whatsapp,*/
                auth: {
                    username: null,
                    password: ''
                },
                recovery: false,
                hasVisiblePassword: false,
                recovery_traveller: null
			}
		},
        computed: {
            ...mapGetters({
				alert: _GlobalHelper.getters.authenticate
            }),
            getProgress() {
                let progress = 0
                if (this.auth.password.length !== 6) {
                    progress+=20
                }

                return progress
            }
		},
		methods: {
			...mapMutations({
                setAuthenticate: _GlobalHelper.mutations.setAuthenticate,
			}),
            ...mapActions({
                recovery_password: _GlobalHelper.actions.recoveryPassword
            }),

            closeRecovery() {
			    this.recovery =! this.recovery
            },

			closeAlert() {

				this.setAuthenticate({
					show: false,
                    custom_button_label: null
				})
            },

            signIn() {

                this.$emit('sign-in', this.auth)

            },

            recoveryPassword(type) {

                console.log(type)

                this.recovery_password({
                    send_type: type,
                    phone: this.auth.username
                }).then(response => {
                    this.recovery = false
                })
            }
		},
    }
</script>

<style lang="scss">
	.mu-dialog-title {
		color: #005296;
		justify-content: space-around;
		border-top: black;
	}
	.mu-dialog-fullscreen {
		max-width: 78% !important;
		max-height: 86% !important;
		position: initial;
	}
	.mu-dialog-scrollable .mu-dialog-body {
		height: inherit;
	}

    .vs-input {
        width: 100% !important;
    }

    .vs-input::-moz-placeholder {
        color: red !important;
    }

    .icon {
        cursor: pointer;
    }

</style>
